import { render } from "./LoginInput.vue?vue&type=template&id=3bc38bb7"
import script from "./LoginInput.vue?vue&type=script&lang=js"
export * from "./LoginInput.vue?vue&type=script&lang=js"

import "./LoginInput.vue?vue&type=style&index=0&id=3bc38bb7&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__